export default __webpack_public_path__ + "static/media/generic-map.f7d46aca.mp4";